import React from 'react'
import Dialog from 'components/dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import Typography from '@material-ui/core/Typography'
import ShareBox from 'components/share-box'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  titleRoot: {
    padding: theme.spacing(3, 3, 1),
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 700,
    lineHeight: 1.3,
    color: '#172024',
    marginBottom: theme.spacing(0.75),
  },
  subtitle: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
  },
  content: {
    padding: theme.spacing(1, 3, 3),
  },
}))

const ShareEventDialog = ({
  isOpen,
  setIsOpen,
  url,
  title,
  titleText,
  eventId,
}) => {
  const classes = useStyles()
  const resolvedTitle = titleText || 'Share event link'
  const resolvedSubtitle = 'Let students register directly from this link.'

  return (
    <Dialog
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      maxWidth="sm"
      fullWidth
      showCloseButton
    >
      {() => (
        <>
          <DialogTitle disableTypography classes={{ root: classes.titleRoot }}>
            <Typography component="h2" className={classes.title}>
              {resolvedTitle}
            </Typography>
            <Typography className={classes.subtitle}>
              {resolvedSubtitle}
            </Typography>
          </DialogTitle>
          <DialogContent classes={{ root: classes.content }}>
            <ShareBox
              url={url}
              title={title}
              showBookingUrl
              att="pga-group-event"
              shareId={eventId}
            />
          </DialogContent>
        </>
      )}
    </Dialog>
  )
}

export default ShareEventDialog
